import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  TextField,
  Grid,
  LinearProgress,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TableHead,
  IconButton,
  TableContainer,
  Paper,
} from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumb from '../../../Components/BreadCrumb';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenCheckbox from '../../../global_components/KenCheckbox/index';
import KenDialogBox from '../../../global_components/KenDialogBox';
import routes from '../../../Utils/routes.json';
import { FaRegEdit } from 'react-icons/fa';
import { RiEditLine, RiFilterLine } from 'react-icons/ri';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenPopover from '../../../Components/KenPopOver';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenSelect from '../../../global_components/KenSelect';
import KenInputField from '../../../global_components/KenInputField';
import { RiCheckFill } from 'react-icons/ri';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AddIcon from '@material-ui/icons/Add';
import { HiOutlinePencilAlt, HiOutlineTrash } from 'react-icons/hi';
import FacultyTable from './FacultyTable';
import Checkbox from '@material-ui/core/Checkbox';
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import FormControl from '@material-ui/core/FormControl';
import './styles.scss';
import {
  selectOptions,
  todayDropDown,
  campusOptions,
  courseOptions,
  intakeOptions,
  facultyDropDown,
  modeDropdown,
  classRoomOptions,
  dropDownOption,
  resourceDropdown,
  courses,
  yearOptions,
} from './data/data';
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from 'react-icons/ai';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
import {
  getAcademicFilter,
  getCourseVersionData,
  postCourseVersionData,
  getImportTermwiseSubjectData,
  getMasterSubjectsWithTermData,
  getSectionOfferingData,
  postSectionOfferingData,
} from '../../../Utils/apiServices';
const defaultValues = {
  courseName: '',
  intake: '',
  course: '',
  startDate: '',
  endDate: '',
};
const FacultyCell = (row, popOverOpen, handleDialog) => {
  if (row) {
    return (
      <p onMouseEnter={(e) => popOverOpen(e)} onMouseLeave="normalImg(this)">
        {row}
      </p>
    );
  } else {
    return (
      <Button
        // className={classes.filterButton}
        variant="contained"
        color="primary"
        onClick={handleDialog}
      >
        Select CR/faculty
      </Button>
    );
  }
};
const arrayBreadCrumb = [{ head: 'BACK', url: routes.addActivity }];
const UserCell = (row, name, popOverOpen) => {
  return (
    <p style={{ marginRight: '10px' }} onMouseEnter={(e) => popOverOpen(e)}>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />{' '}
      {name}
    </p>
  );
};
const availableCell = (rows) => {
  if (rows === 'available') {
    return <div style={{ color: '#1DE831' }}>available</div>;
  } else {
    return <div style={{ color: '#EF4060' }}>unavailable</div>;
  }
};
const useStyles = makeStyles((theme) => ({
  faculty_buttons: {
    marginLeft: '20rem',
  },
  add_faculty_button: {
    marginLeft: '2rem',
  },
  // checkbox: {
  //   marginTop: '24px',
  // },
  selectFacultyModal: {
    width: '10rem',
  },
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  filterButton: {
    marginRight: '5px',
  },
  actionBtns: {
    margin: '2px',
    borderRadius: '15px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '13px',
    color: '#505F79',
    borderBottom: 'none',
  },

  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  popoverMainTitle: {
    width: '100%',
    background: '#19228c',
    color: '#fff',
    padding: '7px 15px',
    fontWeight: '700',
  },
  customTableColumn: {
    color: '#02195E',
    fontWeight: '700',
  },
  customTableColumnPop: {
    color: '#02195E',
    borderBottom: 'none',
  },
}));
const FacultyDetails = () => {
  const location = useLocation();
  const createData = (
    id,
    courseName,
    courseId,
    credit,
    startDate,
    endDate,
    section,
    faculty,
    saves
  ) => ({
    id,
    courseName,
    courseId,
    credit,
    startDate,
    endDate,
    section,
    faculty,
    saves,
  });

  const createSectionData = (
    id,
    checkbox,
    section,
    sectionStrength,
    saves
  ) => ({
    id,
    checkbox,
    section,
    sectionStrength,
    saves,
  });
  const createFacultyData = (
    id,
    checkbox,
    section,
    sectionStrength,
    facultyView,
    saves
  ) => ({
    id,
    checkbox,
    section,
    sectionStrength,
    facultyView,
    saves,
  });
  const selectClassRoom = [
    {
      id: 1,
      check: false,
      section: 'section',
      grade: 'A',
      startTime: '10:00 AM',
      endTime: '1:00PM',
      SelectClassroom: classRoomOptions,
      addFaculty: 'Add Faculty',
      icon: <AddIcon />,
    },
    {
      id: 2,
      check: false,
      section: 'section',
      grade: 'B',
      startTime: '11:00 AM',
      endTime: '3:00PM',
      SelectClassroom: classRoomOptions,
      addFaculty: 'Add Faculty',
      icon: <AddIcon />,
    },
    {
      id: 3,
      check: false,
      section: 'section',
      grade: 'C',
      startTime: '10:00 AM',
      endTime: '1:00PM',
      SelectClassroom: classRoomOptions,
      addFaculty: 'Prof Raju',
      icon: <RiEditLine size={15} />,
    },
  ];
  const masterHead = [
    {
      Header: 'Week No.',
      accessor: 'credit',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'courseName',
      disableGlobalFilter: false,
    },
    // {
    //   Header: 'Duration in Weeks',
    //   accessor: 'durationInWeeks',
    //   disableGlobalFilter: false,
    // },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      disableGlobalFilter: false,
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      disableGlobalFilter: false,
    },
  ];
  const classes = useStyles();
  const history = useHistory();
  const [startDay, setStartDay] = useState(todayDropDown[0].value);
  const [endDay, setEndDay] = useState(todayDropDown[0].value);
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [selectValue1, setSelectValue1] = useState(selectOptions[0].value);
  const [selectValue2, setSelectValue2] = useState(selectOptions[0].value);
  const [selectValue3, setSelectValue3] = useState(selectOptions[0].value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEls, setAnchorEls] = React.useState(null);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [endDate, setEndDate] = useState('25-02-2022');
  const [filters, setFilters] = useState({});
  const [facultyDrop, setFacultyDrop] = useState({});
  const opens = Boolean(anchorEls);
  const [totalDay, setTotalDay] = useState('');
  const [totalHrWeek, setTotalHrWeek] = useState('');
  const ids = opens ? 'simple-popover' : undefined;
  const [sendBulkEmailDialog, setSendBulkEmailDialog] = useState(false);
  const [sendEmailDialog, setSendEmailDialog] = useState(false);
  const [filterDialog, setFilterDialog] = useState(false);
  const [facultyDialog, setFacultyDialog] = useState(false);
  const [selectAllData, setSelectAllData] = useState(false);
  const [cloneDialog, setCloneDialog] = useState(false);
  const [value, setValue] = React.useState('Online');
  const [formValues, setFormValues] = useState(defaultValues);
  const [noOfStudent, setNoOfStudent] = useState('');
  const [accordienCheck, setAccordienCheck] = useState(true);
  const [selectFaculty, setSelectFaculty] = useState(selectClassRoom);
  const [rowFaculty, setRowFaculty] = useState([]);
  const [facultyName, setFacultyName] = useState('');
  const [programName, setProgramName] = useState(
    location?.state?.programName || sessionStorage.getItem('programName')
  );
  const [year, setYear] = useState(
    location?.state?.year || sessionStorage.getItem('year')
  );
  const [intake, setIntake] = useState(
    location?.state?.intake || sessionStorage.getItem('intake')
  );
  const [term, setTerm] = useState();
  const [termDropdown, setTermDropdown] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState([]);
  const [editIndex, setEditIndex] = useState();
  const [newActivity, setNewActivity] = useState(false);
  const [indexVal, setIndexVal] = useState();
  const [disableAddSubject, setDisableAddSubject] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [masterDialog, setMasterDialog] = useState(false);
  const [masterImportSuccess, setMasterImportSuccess] = useState(false);
  const [disableMaster, setDisableMaster] = useState(true);
  const [masterAccordian, setMasterAccordian] = useState(true);
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState();
  const [programID, setProgramID] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectionViewDialog, setSectionViewDialog] = useState(false);
  const [facultyData, setFacultyData] = useState([]);
  const [facultyViewDialog, setFacultyViewDialog] = useState(false);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const data = [
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Raleigh Avieson',
        handlePopoverOpen
      ),
      phone: 'Avieson',
      email: 'ravieson0@soup.io',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Fleur Fowler',
        handlePopoverOpen
      ),
      phone: 'Fowler',
      email: 'ffowler1@ucla.edu',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Nealy Leitch',
        handlePopoverOpen
      ),
      phone: 'Leitch',
      email: 'nleitch2@networkadvertising.org',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Carolyne Angrock',
        handlePopoverOpen
      ),
      phone: 'Angrock',
      email: 'cangrock3@washingtonpost.com',
      type: 'internal',
      availability: availableCell('unavailable'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Abeu Aiers',
        handlePopoverOpen
      ),
      phone: 'Aiers',
      email: 'aaiers4@weibo.com',
      type: 'internal',
      availability: availableCell('unavailable'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Penny Scrivinor',
        handlePopoverOpen
      ),
      phone: 'Scrivinor',
      setSelectFaculty,
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Grier Laverick',
        handlePopoverOpen
      ),
      phone: 'Laverick',
      email: 'glaverick6@uol.com.br',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Dur Leile',
        handlePopoverOpen
      ),
      phone: 'Leile',
      email: 'dleile7@spiegel.de',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Claudine Owenson',
        handlePopoverOpen
      ),
      phone: 'Owenson',
      email: 'cowenson8@gizmodo.com',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Stefa True',
        handlePopoverOpen
      ),
      phone: 'True',
      email: 'strue9@jigsy.com',
      type: 'internal',
      availability: availableCell('unavailable'),
    },
  ];
  const [selectOptionsCourse, setSelectOptionsCourse] = React.useState([]);
  const [selectSubjectCodeOption, setSelectSubjectCodeOption] = React.useState(
    []
  );
  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };
  const handleSelectRow = (evt, row, index) => {
    setRowFaculty(row);
    console.log('row', row);
    // TODO code here to perform actions on selecting row in table
  };
  const handlefacultyDialog = () => {
    setFacultyDialog((prevState) => !prevState);
    // setRowFaculty([]);
  };
  const addFacultyName = (id) => {
    const rowId = [...rowFaculty, id];
    setRowFaculty(rowId);
    handlefacultyDialog();
  };
  const onClickCheckBox = (id) => {
    let uniqueArr = [];
    let rowId = [...rowFaculty, id];
    rowId.sort(function (a, b) {
      return a - b;
    });
    for (let i = 0; i <= rowId.length; i++) {
      if (rowId[i] == rowId[i + 1]) {
        i++;
      } else {
        uniqueArr.push(rowId[i]);
      }
    }
    setRowFaculty(uniqueArr);
  };
  const addFaculty = (id) => {
    handlefacultyDialog();
  };
  useEffect(() => {
    console.log('uniquestate', rowFaculty);
    const newFacultyList = selectFaculty.map((faculty) =>
      rowFaculty.includes(faculty.id)
        ? {
            ...faculty,
            addFaculty: facultyName,
            icon: <RiEditLine />,
          }
        : faculty
    );
    setSelectFaculty(newFacultyList);
  }, [facultyName]);

  function handleSendEmailDialog() {
    console.log('object');
    setSendEmailDialog((prevState) => !prevState);
  }
  const selectOptionsMode = [
    {
      label: 'F2F',
      value: 'f2f',
    },
    {
      label: 'Offline',
      value: 'offline',
    },
    {
      label: 'Online',
      value: 'online',
    },
  ];
  const taskOptions = [
    {
      label: 'Complete',
      value: '1',
    },
    {
      label: 'In Progress',
      value: '2',
    },
    {
      label: 'Yet to Complete',
      value: '3',
    },
  ];
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsCourse[0]?.value
  );
  const [selectValueMode, setSelectValueMode] = useState(
    selectOptionsMode[0].value
  );
  const progressStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    color: 50 > 0 ? '#27AE60' : '#EF4060',
  };
  const progressStyle1 = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    color: 0 > 0 ? '#27AE60' : '#EF4060',
  };
  const [rowSubject, setRowSubject] = useState([]); // Table Row
  const handleFacultyDrop = (e) => {
    const { name, value } = e.target;
  };
  const [previous, setPrevious] = useState({});
  const [dataSubject, setDataSubject] = useState({});
  const [newSectionData, setNewSectionData] = useState({});
  const [newFacultyData, setNewFacultyData] = useState({});
  const [activateDelete, setActivateDelete] = useState(true);
  const [activateEdit, setActivateEdit] = useState(false);
  const [checkedData, setCheckedData] = useState({});
  const [toggleReload, setToggleReload] = useState(false);
  const [editedItem, setEditedItem] = useState({});

  const onChange = (e, row) => {
    let edit = activateEdit;
    if (e.target.type === 'checkbox') {
      setActivateDelete(!activateDelete);
      setActivateEdit(false);
      return edit == false;
    }
    const selectedOption = selectOptionsCourse.filter((item) => {
      if (item.value === e.target.value) {
        return item;
      }
    });
    const setData = selectedOption[0];
    console.log('rrrrrrrrrrrrrrrrrrrrrrrrrrrr', setData);

    if (row?.section) {
      if (edit === true) {
        let newData = sectionData;
        newData.forEach((item) => {
          if (item.id === row.id) {
            item.sectionStrength = e.target.value;
            return setEditedItem(item);
          }
        });
        setSectionData(newData);
      }
    }
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newData = [...rowSubject];
    newData[editIndex]?.array.forEach((row) => {
      if (row.id === id) {
        console.log('vvvvvvvvvvvvvvvvvvvvvvvvvvvvv', value);
        if (setData) {
          row[name] = value;
          row['courseId'] = setData?.courseId;
          row['credit'] = setData?.credit;
        } else {
          row[name] = value;
          // row['courseId'] = setData?.courseId
          // row['credit'] = setData?.credit
        }
      }
    });
    setRowSubject(newData);
  };
  const dateFormatter = (date) => {
    let dArr = date.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };

  const onToggleEditMode = (check, id, index) => {
    const newData = [...rowSubject];
    newData[index]?.array.forEach((row) => {
      if (row.id === id) {
        row.isEditMode = true;
        if (check === 'done') {
          setLoading(true);
          const payload = {
            CourseVersion: {
              termName: newData[index].courseName,
              courseVersionId: null,
              courseId: row.courseId,
              startDate: dateFormatter(row.startDate),
              endDate: dateFormatter(row.endDate),
            },
          };
          postCourseVersionData(payload)
            .then((res) => {
              setLoading(false);
              alert(res.message);
              row.isEditMode = false;
              setRowSubject(newData);
              console.log('newDat', newData);
              setDisableAddSubject(false);
            })
            .catch((err) => {
              alert('Failed to add. Please try again.');
              setLoading(false);
              row.isEditMode = false;
              setRowSubject(newData);
              console.log('newDat', newData);
              setDisableAddSubject(false);
            });
        } else if (check === 'edit') {
          setDisableAddSubject(true);
          row.isEditMode = true;
          setRowSubject(newData);
        }
      }
    });
    setEditIndex(index);
  };
  const onRevert = (id, rowSubject, index) => {
    setDisableAddSubject(false);
    const newData = [...rowSubject];
    newData[index].array.map((row) => {
      if (row.id === id) {
        return (row.isEditMode = false);
      }
    });
    setRowSubject(newData);
  };
  const handleCancel = (row, rowSubject, index) => {
    setDisableAddSubject(false);
    const newData = [...rowSubject];
    newData[index].array.pop((item) => item.id === row);
    setRowSubject(newData);
  };
  const columnArray = [
    'Subject',
    'Subject Code',
    'Credits',
    'Start Date',
    'End Date',
    'Section',
    'Faculty',
    'Action',
  ];
  const sectionArray = ['', 'Section', 'Section Strength', 'Action'];
  const facultyArray = ['', 'Section', 'Section Strength', 'Faculty', 'Action'];
  const facultyOptions = [
    { label: 'Prof. Pranav', value: 'Prof. Pranav' },
    { label: 'Prof. Ganesh', value: 'Prof. Ganesh' },
    { label: 'Prof. Sandesh', value: 'Prof. Sandesh' },
  ];
  const handlePopoverClose = () => {
    setAnchorEls(null);
  };
  const handleSelectChangeSubject = (event, index) => {
    setLoading(true);
    dataSubject.courseName = event.target.value;
    setSelectValueSubject(event.target.value);
    const newData = [...selectOptionsCourse];
    const selectedOption = newData.filter((item) => {
      if (item.value === event.target.value) {
        return item;
      }
    });
    const setData = selectedOption[0];
    setDataSubject({
      ...dataSubject,
      courseName: setData.value,
      courseId: setData.courseId,
      credit: setData.credit,
      id: setData.id,
    });
    console.log('============', setData, event.target.value);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleFilter = (e, data) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
    if (e.target.name === 'courseName') {
      setProgramName(value);
      let newData = data.filter((element) => {
        return element.label === e.target.value;
      });
      let termData = [];
      newData[0]?.terms.map((item) => {
        termData.push({ label: item.name, value: item.name });
      });
      termData.push({ label: 'All', value: 'All' });
      // setProgramID(newData[0].id)
      setTermDropdown(termData);
      setTerm(undefined);
    } else if (e.target.name === 'intake') {
      setIntake(value);
    }
  };
  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };
  function handleSendEmailDialog() {
    console.log('object');
    setSendEmailDialog((prevState) => !prevState);
  }
  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleChangedCredit = (event) => {
    dataSubject.credit = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedSubjectCode = (event) => {
    dataSubject.courseId = event;
    const select = selectSubjectCodeOption.filter((item) => {
      if (item.label == event) {
        return item;
      }
    });
    setSelectSubjectCodeOption(select);
  };
  const handleChangedStudent = (event) => {
    dataSubject.student = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedDate = (event) => {
    dataSubject.startDate = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedEndDate = (event) => {
    dataSubject.endDate = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleSubject = (check, id, index) => {
    setDataSubject({});
    setDisableAddSubject(true);
    if (check == 'save') {
      setLoading(true);
      let savedData = dataSubject;
      let termName = id[index].courseName;
      const payload = {
        CourseVersion: {
          termName: termName,
          courseVersionId: null,
          courseId: savedData.id,
          startDate: dateFormatter(savedData.startDate),
          endDate: dateFormatter(savedData.endDate),
        },
      };
      postCourseVersionData(payload)
        .then((res) => {
          console.log('res', res);
          id[index].array.forEach((item) => {
            item.isEditMode = false;
          });
          setNewActivity(!newActivity);
          setLoading(false);
          setDisableAddSubject(false);
        })
        .catch((err) => {
          setLoading(false);
          alert('Failed to add. Please try again.');
          setDisableAddSubject(false);
        });
    } else {
      const newData = [...rowSubject];
      newData[index]?.array.push(
        createData(
          `rows${rowSubject[index]?.array.length}`,
          <KenSelectWrap
            label="Subject"
            options={selectOptionsCourse}
            value={dataSubject.courseName}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSelectChangeSubject(e, index)}
            required
          />,
          <p>{dataSubject.courseId}</p>,
          <p>{dataSubject.credit}</p>,
          <KenDateTimePicker
            name={'startDate'}
            value={dataSubject.startDate}
            label="Start date"
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedDate(e)}
          />,
          <KenDateTimePicker
            name={'endDate'}
            placeholder="Start Time"
            label="End date"
            value={dataSubject.endDate}
            type="date"
            required={true}
            onChange={(e) => handleChangedEndDate(e)}
          />,
          <p>View</p>,
          <p>View</p>,
          true
        )
      );
      setRowSubject(newData);
      setIndexVal({ id, newData, index });
    }
  };
  const handleSelectChange1 = (e) => {
    setSelectValue1(e.target.value);
  };
  const handleSelectChange2 = (e) => {
    setSelectValue2(e.target.value);
  };
  const handleSelectChange3 = (e) => {
    setSelectValue3(e.target.value);
  };
  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }
  function handleCloneDialog() {
    setCloneDialog((prevState) => !prevState);
  }
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const masterImportDialog = () => {
    setMasterDialog(true);
    setMasterData([]);
    setLoading(false);
    if (!masterDialog) {
      setLoading(true);
      let querry = `?academicProgramId=${programID}`;
      getMasterSubjectsWithTermData(querry)
        .then((res) => {
          console.log(res);
          let responseData = res?.message;
          if (responseData === 'No Data Found') {
            setMasterData([]);
          } else {
            let values = Object.values(res);
            let alteredData = values.map((el, ind) => {
              return {
                courseName: el?.termName,
                array: [...el?.specialWrapperList[0]?.courseWrapperList],
              };
            });
            console.log(alteredData, 'alteredData');
            setMasterData(alteredData);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };
  const masterImportCancel = () => {
    setMasterData([]);
    setMasterDialog(false);
  };
  const masterImportSubmit = () => {
    setLoading(true);
    const data = `?academicProgramId=${programID}&intake=${intake}&year=${year}`;
    getImportTermwiseSubjectData(data)
      .then((res) => {
        alert(res.message);
        setLoading(false);
        setMasterImportSuccess(!masterImportSuccess);
        setMasterDialog(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // ********************************** Section View *******************************************
  const returnSectionChar = (char) => {
    let newChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return newChar.charAt(char);
  };
  const onToggleCancelBtn = (row, sectionData, index) => {
    const newData = [...sectionData];
    newData.pop((item) => item.id === row);
    setSectionData(newData);
  };
  const handleSectionStrength = (event) => {
    newSectionData.sectionStrength = event.target.value;
  };
  const onToggleSaveBtn = (check, data, index) => {
    if (check == 'save') {
      setLoading(true);
      let newData = newSectionData;
      let replaceString = String(newData?.section).replace('Section ', '');
      let payload = {
        Operation: 'Create',
        CourseOffering: {
          courseOfferingSectionId: replaceString,
          courseOfferingCapacity: newData?.sectionStrength,
          courseOfferingId: '',
          courseVersionId: selectedRow[0].id,
        },
      };
      console.log('payload', payload);
      postSectionOfferingData(payload)
        .then((res) => {
          console.log('res', res);
          sectionData.forEach((item) => {
            item.isEditMode = false;
          });
          setSectionData(data);
          setToggleReload(!toggleReload);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };
  const addToSectionData = (check, id, index) => {
    if (check === 'add') {
      const newData = [...sectionData];
      let tempData = newSectionData;
      tempData.section = `Section ${returnSectionChar(sectionData.length)}`;
      setNewSectionData(tempData);
      newData.push(
        createSectionData(
          `rows${sectionData.length}`,
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={newSectionData.checkbox}
            onChange={(event) => selectedCheckBoxItem(event, sectionData)}
            color="primary"
          />,
          <KenInputField
            label={'Section'}
            value={newSectionData.section}
            optionalLabel={false}
            disabled={true}
            style={{ fontSize: 12 }}
          />,
          <KenInputField
            label={'Section Strength'}
            value={newSectionData.sectionStrength}
            optionalLabel={false}
            onChange={(e) => handleSectionStrength(e)}
            style={{ fontSize: 12 }}
          />,
          true
        )
      );
      console.log('new section data', newData);
      setSectionData(newData);
    } else {
      let selectedData = checkedData;
      setLoading(true);
      let payload = {
        Operation: 'Delete',
        CourseOffering: {
          courseOfferingId: selectedData.id,
        },
      };
      console.log('payload', payload);
      postSectionOfferingData(payload)
        .then((res) => {
          console.log('res', res);
          sectionData.forEach((item) => {
            item.isEditMode = false;
          });
          setSectionData(data);
          setToggleReload(!toggleReload);
          setActivateDelete(true);
        })
        .catch((err) => {
          setLoading(false);
          setActivateDelete(true);
        });
    }
  };
  const onToggleEditBtn = (check, id, index) => {
    const newData = [...sectionData];
    newData.forEach((row) => {
      if (row.id === id) {
        row.isEditMode = true;
        if (check === 'done') {
          setLoading(true);
          let replaceString = String(editedItem?.section).replace(
            'Section ',
            ''
          );
          let payload = {
            Operation: 'Update',
            CourseOffering: {
              courseOfferingSectionId: replaceString,
              courseOfferingCapacity: Number(editedItem?.sectionStrength),
              courseOfferingId: editedItem?.id,
              courseVersionId: '',
            },
          };
          console.log('payload', payload);
          postSectionOfferingData(payload)
            .then((res) => {
              setToggleReload(!toggleReload);
            })
            .catch((err) => {
              setLoading(false);
            });
        } else if (check === 'edit') {
          setActivateEdit(true);
          row.isEditMode = true;
          setSectionData(newData);
        }
      }
    });
  };
  const onToggleRevertBtn = (id, sectionData, index) => {
    const newData = [...sectionData];
    newData.map((row) => {
      if (row.id === id) {
        return (row.isEditMode = false);
      }
    });
    setSectionData(newData);
    setToggleReload(!toggleReload);
  };
  const sectionCell = (item) => {
    let data = [];
    data.push(item);
    setSelectedRow(data);
    setSectionViewDialog(true);
  };
  React.useEffect(() => {
    setLoading(true);
    let params = `courseVersionId=${selectedRow.id}`;
    getSectionOfferingData(params)
      .then((res) => {
        let data = [];
        Object.entries(res).map((items) => {
          data.push({
            section: `Section ${items[1].courseOfferingSectionId}`,
            id: items[1].id,
            checkbox: false,
            sectionStrength: items[1].courseOfferingCapacity,
          });
        });
        setSectionData(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setSectionData([]);
      });
  }, [toggleReload, selectedRow]);
  const sectionViewCancel = () => {
    setSectionViewDialog(false);
  };
  const sectionViewSubmit = () => {
    setSectionViewDialog(false);
  };
  const selectedCheckBoxItem = (event, row, data) => {
    console.log('checkbox', event, row, data);
  };
  // ********************************** Section View *******************************************
  const editCell = (cell, row) => {
    if (cell === 'section') {
      sectionCell(row);
    } else {
      facultyCell(row);
    }
  };
  React.useEffect(() => {
    const facultyData = [
      {
        id: 'secA',
        checkbox: false,
        section: 'Section A',
        sectionStrength: 50,
        facultyView: '',
      },
      {
        id: 'secB',
        checkbox: false,
        section: 'Section B',
        sectionStrength: 40,
        facultyView: 'Prof. Pranav',
      },
    ];
    setFacultyData(facultyData);
  }, []);
  // ********************************** Faculty View *******************************************
  const facultyCell = (item) => {
    let data = [];
    data.push(item);
    setSelectedRow(data);
    setFacultyViewDialog(true);
    console.log('facultyCell', item);
  };
  const facultyViewCancel = () => {
    setFacultyViewDialog(false);
  };
  const facultyViewSubmit = () => {
    setFacultyViewDialog(false);
  };
  const handleSelectFaculty = (e) => {
    let tempData = newFacultyData;
    tempData.faculty = e.target.value;
  };
  // const addToFacultyData = (check, id, index) => {
  //   const newData = [...facultyData];
  //   let tempData = newFacultyData;
  //   tempData.section = `Section ${returnSectionChar(facultyData.length)}`;
  //   setNewFacultyData(tempData);
  //   newData.push(
  //     createFacultyData(
  //       `rows${facultyData.length}`,
  //       <KenCheckbox
  //         name={`checkbox`}
  //         className={classes.checkbox}
  //         value={newFacultyData.checkbox}
  //         onChange={(event) => selectedCheckBoxItem(event, facultyData)}
  //         color="primary"
  //       />,
  //       <KenInputField
  //         label={'Section'}
  //         value={newFacultyData.section}
  //         optionalLabel={false}
  //         disabled={true}
  //         style={{ fontSize: 12 }}
  //       />,
  //       <KenInputField
  //         label={'Section Strength'}
  //         value={newFacultyData.sectionStrength}
  //         optionalLabel={false}
  //         onChange={(e) => handleSectionStrength(e)}
  //         style={{ fontSize: 12 }}
  //       />,
  //       <KenSelectWrap
  //         label="Faculty"
  //         options={facultyOptions}
  //         value={newFacultyData.faculty}
  //         dropdownColor="#FFFFFF"
  //         onChange={(e) => handleSelectFaculty(e)}
  //         required
  //       />,
  //       true
  //     )
  //   );
  //   console.log('new section data', newData);
  //   setFacultyData(newData);
  // };
  const onFacultyCancelBtn = (row, data, index) => {
    const newData = [...facultyData];
    newData.pop((item) => item.id === row);
    setFacultyData(newData);
  };
  const handleFacultyStrength = (event) => {
    newFacultyData.sectionStrength = event.target.value;
  };
  const onFacultySaveBtn = (check, data, index) => {
    if (check == 'save') {
      data.forEach((item) => {
        item.isEditMode = false;
      });
      setFacultyData(data);
    }
  };
  const onFacultyEditBtn = (check, id, index) => {
    const newData = [...facultyData];
    newData.forEach((row) => {
      if (row.id === id) {
        row.isEditMode = true;
        if (check === 'done') {
          row.isEditMode = false;
          setRowSubject(newData);
        } else if (check === 'edit') {
          row.isEditMode = true;
          setFacultyData(newData);
        }
      }
    });
  };
  const onFacultyRevertBtn = (id, facultyData, index) => {
    const newData = [...facultyData];
    newData.map((row) => {
      if (row.id === id) {
        return (row.isEditMode = false);
      }
    });
    setFacultyData(newData);
  };
  const addFacultyToAll = () => {};
  // ********************************** Faculty View *******************************************
  React.useEffect(() => {
    const newData = [...rowSubject];
    console.log('indexVal', indexVal);
    newData[indexVal?.index]?.array.pop();
    newData[indexVal?.index]?.array.push(
      createData(
        `rows${rowSubject[indexVal?.index]?.array.length}`,
        <KenSelectWrap
          label="Subject"
          options={selectOptionsCourse}
          value={dataSubject.courseName}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleSelectChangeSubject(e, indexVal?.index)}
          required
        />,
        <p>{dataSubject.courseId}</p>,
        <p>{dataSubject.credit}</p>,
        <KenDateTimePicker
          name={'startDate'}
          value={dataSubject.startDate}
          label="Start date"
          type="date"
          required={true}
          onChange={(e) => handleChangedDate(e)}
        />,
        <KenDateTimePicker
          name={'name'}
          placeholder="Start Time"
          label="End date"
          value={dataSubject.endDate}
          type="date"
          required={true}
          onChange={(e) => handleChangedEndDate(e)}
        />,
        <p>View</p>,
        <p>View</p>,
        true
      )
    );
    setRowSubject(newData);
  }, [dataSubject]);
  React.useEffect(() => {
    setLoading(true);
    let locationData = history?.location?.state?.batchName;
    let programID = history?.location?.state?.id;
    setProgramID(programID);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let campusOptions = [];
        let subjectOptions = [];
        let subjectCodeOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            terms: JSON.parse(keyVal.terms),
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        Object.entries(res['Courses']).map(([item, keyVal]) => {
          subjectOptions.push({
            label: item,
            value: item,
            credit: keyVal.credit,
            id: keyVal.id,
            courseId: keyVal.courseId,
          });
          subjectCodeOptions.push({
            label: keyVal.courseId != null ? keyVal.courseId : '-',
            value: keyVal.id,
          });
        });
        setSelectOptionsCourse(subjectOptions);
        console.log('subjectCodeOptions', subjectCodeOptions);
        setSelectSubjectCodeOption(subjectCodeOptions);
        setCourseOptions(courseOptions);
        setCampusOptions(campusOptions);
        if (locationData != undefined) {
          setProgramName(location?.state?.programName);
          let e = { target: { name: 'courseName', value: locationData } };
          handleFilter(e, courseOptions);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  React.useEffect(() => {
    setLoading(true);
    let data;
    intake != undefined && year != undefined
      ? (data = `?programName=${programName}&intake=${intake}&year=${year}`)
      : year != undefined
      ? (data = `?programName=${programName}&year=${year}`)
      : intake != undefined
      ? (data = `?programName=${programName}&intake=${intake}`)
      : (data = `?programName=${programName}`);
    if (programName != undefined && intake != undefined && year != undefined) {
      setDisableMaster(false);
    }
    getCourseVersionData(data).then((res) => {
      console.log('data', res);
      if (res.message === 'No Data Found') {
        setRowSubject([]);
      } else {
        let key = Object.keys(res);
        let values = Object.values(res);
        let alteredData = key.map((el, ind) => {
          return {
            courseName: el,
            array: [
              ...values[ind].map((item) => ({
                ...item,
                section: 'View',
                faculty: 'View',
              })),
            ],
          };
        });
        console.log(alteredData, 'alteredData');
        setRowSubject(alteredData);
      }
      setLoading(false);
    });
  }, [programName, intake, year, newActivity, masterData]);
  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Term-Wise Subject List
          </Typography>
        </Toolbar>
      </AppBar>
      {/* Filters */}
      <Box mt={2} mb={2} className={classes.sortingSection}>
        <KenSelect
          name="courseName"
          label="Academic Program *"
          options={courseOptions}
          value={programName}
          dropdownColor="#ffffff"
          onChange={(el) => handleFilter(el, courseOptions)}
          required={true}
        />
        <KenSelect
          label="Year *"
          options={yearOptions}
          value={year}
          dropdownColor="#ffffff"
          onChange={(e) => setYear(e.target.value)}
          required={true}
        />
        <KenSelectWrap
          name="intake"
          label="Intake *"
          options={intakeOptions}
          value={intake}
          dropdownColor="#FFFFFF"
          onChange={(el) => handleFilter(el, intakeOptions)}
          required
        />
        {/* <KenSelectWrap
          name="campus"
          label="Campus"
          options={campusOptions}
          value={filters.campus}
          dropdownColor="#FFFFFF"
          onChange={handleFilter}
          required
        />
        <KenDateTimePicker
          label="Start Date"
          inputBaseRootClass={classes.kenDateTimePickerColor}
          placeholder="Start Date"
          value={startDate}
          type="date"
          required={true}
          defaultValue={startDate}
          onChange={manageStartDate}
        />
        <KenDateTimePicker
          label="End Date"
          placeholder="End Date"
          inputBaseRootClass={classes.kenDateTimePickerColor}
          value={endDate}
          type="date"
          required={true}
          defaultValue={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <KenInputField
          label="No of students"
          required
          placeholder="No of students"
          name="no of students"
          onChange={(e) => setNoOfStudent(e.target.value)}
          value={noOfStudent}
          className={classes.textInputField}
        />
        <KenSelectWrap
          name="Semester"
          label="semester"
          options={selectOptions}
          value={filters.intake}
          dropdownColor="#FFFFFF"
          onChange={handleFilter}
          required
        /> */}
      </Box>
      <Box mt={2} mb={2} className={classes.mainActions}>
        {/* <Button
          // className={classes.filterButton}
          startIcon={<RiFilterLine />}
          variant="contained"
          color="primary"
          onClick={handleFilterDialog}
        >
          Filter
        </Button> */}
        <Button
          className={classes.filterButton}
          variant="contained"
          color="primary"
          onClick={masterImportDialog}
          disabled={disableMaster}
        >
          Choose Curriculum Version
        </Button>
      </Box>
      {/* Student Data */}
      <>
        {rowSubject.length > 0 ? (
          rowSubject.map((elem, index) => {
            return (
              <Box className="cardlsitbox" style={{ marginBottom: '20px' }}>
                <Accordion expanded={accordienCheck}>
                  <AccordionSummary expandIcon={accordienCheck}>
                    {accordienCheck ? (
                      <AiOutlineMinusSquare
                        size={20}
                        onClick={() => setAccordienCheck(!accordienCheck)}
                      />
                    ) : (
                      <AiOutlinePlusSquare
                        size={20}
                        onClick={() => setAccordienCheck(!accordienCheck)}
                      />
                    )}{' '}
                    &nbsp; {elem.courseName}
                  </AccordionSummary>
                  <KenCard elevation={0}>
                    <h5 style={{ margin: '0 20px 10px 10px' }}>Subjects</h5>
                    <hr></hr>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                        <TableHead>
                          <TableRow>
                            {columnArray.map((ele) => (
                              <TableCell align="left">{ele}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {elem?.array?.length > 0 ? (
                            elem?.array.map((row) => {
                              return (
                                <TableRow key={row.id}>
                                  <KenGridEditable
                                    {...{
                                      row,
                                      onChange,
                                      editCell,
                                      columns: [
                                        {
                                          column_name: 'courseName',
                                          is_inline_edit: false,
                                          inline_edit_type: 'kenSelect',
                                          dropdown: selectOptionsCourse,
                                        },
                                        {
                                          column_name: 'courseId',
                                          is_inline_edit: false,
                                          inline_edit_type: '',
                                          // dropdown: selectSubjectCodeOption,
                                        },
                                        {
                                          column_name: 'credit',
                                          is_inline_edit: false,
                                          inline_edit_type: '',
                                        },
                                        {
                                          column_name: 'startDate',
                                          is_inline_edit: true,
                                          inline_edit_type: 'kenDatePicker',
                                        },
                                        {
                                          column_name: 'endDate',
                                          is_inline_edit: true,
                                          inline_edit_type: 'kenDatePicker',
                                          // dropdown: selectOptionsBatch,
                                        },
                                        {
                                          column_name: 'section',
                                          is_inline_edit: false,
                                          inline_edit_type: 'linkItem',
                                        },
                                        {
                                          column_name: 'faculty',
                                          is_inline_edit: false,
                                          inline_edit_type: 'linkItem',
                                        },
                                      ],
                                    }}
                                  />
                                  <TableCell
                                    className={classes.selectTableCell}
                                    style={{ textAlign: 'center' }}
                                  >
                                    {row.isEditMode ? (
                                      <>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={() =>
                                            onToggleEditMode(
                                              'done',
                                              row.id,
                                              index
                                            )
                                          }
                                        >
                                          Save
                                        </Button>
                                        <IconButton
                                          aria-label="revert"
                                          onClick={() =>
                                            onRevert(row.id, rowSubject, index)
                                          }
                                        >
                                          <RevertIcon />
                                        </IconButton>
                                      </>
                                    ) : (
                                      <>
                                        {!row.saves && (
                                          <IconButton
                                            aria-label="edit"
                                            onClick={() =>
                                              onToggleEditMode(
                                                'edit',
                                                row.id,
                                                index
                                              )
                                            }
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        )}
                                        {row.saves && (
                                          <>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              onClick={() =>
                                                handleSubject(
                                                  'save',
                                                  rowSubject,
                                                  index
                                                )
                                              }
                                            >
                                              Save
                                            </Button>
                                            <IconButton
                                              aria-label="revert"
                                              onClick={() =>
                                                handleCancel(
                                                  row.id,
                                                  rowSubject,
                                                  index
                                                )
                                              }
                                            >
                                              <RevertIcon />
                                            </IconButton>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              {' '}
                              <TableCell
                                className={classes.noDataFound}
                                colSpan={12}
                                align="center"
                              >
                                No Data
                              </TableCell>{' '}
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </KenCard>
                  <div style={{ marginTop: '15px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ marginRight: '15px' }}
                      onClick={() => handleSubject('add', rowSubject, index)}
                      disabled={disableAddSubject}
                    >
                      Add Subjects
                    </Button>
                  </div>
                </Accordion>
              </Box>
            );
          })
        ) : (
          <Box className="cardlsitbox">
            <Accordion expanded={accordienCheck}>
              <AccordionSummary expandIcon={accordienCheck}>
                {accordienCheck ? (
                  <AiOutlineMinusSquare
                    size={20}
                    onClick={() => setAccordienCheck(!accordienCheck)}
                  />
                ) : (
                  <AiOutlinePlusSquare
                    size={20}
                    onClick={() => setAccordienCheck(!accordienCheck)}
                  />
                )}{' '}
                &nbsp; Term 1
              </AccordionSummary>
              <KenCard elevation={0}>
                <h5 style={{ margin: '0 20px 10px 10px' }}>Subjects</h5>
                <hr></hr>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                    <TableHead>
                      <TableRow>
                        {columnArray.map((ele) => (
                          <TableCell align="left">{ele}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        {' '}
                        <TableCell
                          className={classes.noDataFound}
                          colSpan={12}
                          align="center"
                        >
                          No Data
                        </TableCell>{' '}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </KenCard>
            </Accordion>
          </Box>
        )}
      </>
      {/* Next Button */}
      <div className="activityNextButton">
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            history.push({
              pathname: `${routes.addActivity}`,
              state: {
                programName: programName,
                intake: intake,
                year: year,
                id: programID,
              },
            });
            sessionStorage.setItem('programName', programName);
            sessionStorage.setItem('intake', intake);
            sessionStorage.setItem('year', year);
          }}
        >
          Next
        </Button>
      </div>
      {/* Select Classroom / Faculty */}
      <Box className={classes.selectFacultyModal}>
        <KenDialogBox
          title={
            <Grid container>
              <Typography variant="h6" className={classes.dialogHeader}>
                Select Class Room/Faculty
              </Typography>
              <div className={classes.faculty_buttons}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(routes.facultySection)}
                >
                  Invite Faculty
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  // style={{ marginLeft: '180px', padding: '6px 24px 6px 24px' }}
                  onClick={() => addFaculty()}
                  className={classes.add_faculty_button}
                >
                  Add Faculty
                </Button>
              </div>
            </Grid>
          }
          open={sendEmailDialog}
          icon={<RiCheckFill />}
          // maxWidth="md"
          maxWidth="md"
          handleClose={() => handleSendEmailDialog()}
          negativeButtonClick={() => handleSendEmailDialog()}
          positiveButtonClick={() => handleSendEmailDialog()}
          positiveButtonText="Submit"
          negativeButtonText="Cancel"
          dividers
        >
          <Grid container spacing={4}>
            <Table>
              <TableBody>
                {selectFaculty.map((classRoom) => {
                  return (
                    <TableRow>
                      <TableCell className={`${classes.tableBodyStyle}`}>
                        <div className={classes.checkbox}>
                          <Checkbox
                            name="checkedF"
                            onChange={(e) => onClickCheckBox(classRoom.id)}
                            color="primary"
                          />
                        </div>
                      </TableCell>
                      <TableCell className={`${classes.tableBodyStyle}`}>
                        {classRoom.section}
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        {classRoom.grade}
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        {classRoom.startTime}
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        {classRoom.endTime}
                      </TableCell>
                      <TableCell className={classes.tableBodyStyle}>
                        <KenSelectWrap
                          name="classroom"
                          label="Select Classroom"
                          options={classRoom.SelectClassroom}
                          value={filters.campus}
                          dropdownColor="#FFFFFF"
                          onChange={handleFilter}
                          required
                        />
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            onClick={(e) => addFacultyName(classRoom.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {classRoom.addFaculty}{' '}
                          </div>
                          <div style={{ marginLeft: '5px' }}>
                            {classRoom.icon}
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </KenDialogBox>
      </Box>
      {/* Filter Button */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        open={filterDialog}
        icon={<RiCheckFill />}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => handleFilterDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Program"
              options={dropDownOption}
              value={selectValue1}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Semester"
              options={selectOptions}
              value={selectValue1}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange1}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'Start date'}
              value={startDate}
              type="date"
              required={true}
              defaultValue={startDate}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'End date'}
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageEndDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Select Mode"
              options={modeDropdown}
              value={selectValue2}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange2}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Number of Resources"
              options={resourceDropdown}
              value={selectValue3}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange3}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Select Faculty */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Select Faculty{' '}
          </Typography>
        }
        open={facultyDialog}
        // icon={<RiCheckFill />}
        handleClose={() => handlefacultyDialog()}
        negativeButtonClick={() => handlefacultyDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth="lg"
        dividers
      >
        <Grid container spacing={3}>
          <FacultyTable
            data={data}
            setFacultyName={setFacultyName}
            handlefacultyDialog={handlefacultyDialog}
            selectFaculty={selectFaculty}
            setSelectFaculty={setSelectFaculty}
            rowFaculty={rowFaculty}
          />
        </Grid>
      </KenDialogBox>
      {/* CLONE */}
      <KenDialogBox
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Select Program
            </Typography>
            {/* <CloseIcon /> */}
          </>
        }
        open={cloneDialog}
        icon={<RiCheckFill />}
        handleClose={() => handleCloneDialog()}
        negativeButtonClick={() => handleCloneDialog()}
        positiveButtonClick={() => handleCloneDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <KenSelectWrap
              name="courseName"
              label="Program"
              options={courseOptions}
              value={formValues.courseName}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleInputChange(e)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <KenSelectWrap
              name="intake"
              label="Intake"
              options={intakeOptions}
              value={formValues.intake}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleInputChange(e)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <KenSelectWrap
              name="course"
              label="Course"
              options={courses}
              value={formValues.course}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleInputChange(e)}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Grid item xs={12} sm={12}>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={value}
                  onChange={handleChange}
                  style={{ display: 'block', alignItems: 'center' }}
                >
                  {/* <FormLabel component="legend">Mode</FormLabel> */}
                  <b style={{ marginRight: '80px' }}>Mode</b>
                  <FormControlLabel
                    value="online"
                    control={<Radio />}
                    label="Online"
                    style={{ margin: 'auto' }}
                  />
                  <FormControlLabel
                    value="offline"
                    control={<Radio />}
                    label="Offline"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </KenDialogBox>
      {/*  */}
      <KenPopover
        id={ids}
        open={opens}
        anchorEl={anchorEls}
        //  onMouseEnter={handlePopoverOpen}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: { width: 'auto' },
        }}
        hideNegativeButton={true}
        hidePositiveButton={true}
      >
        <Grid>
          <Typography className={classes.popoverMainTitle}>
            Faculty & Class Room Details
          </Typography>
          <Table className={classes.customTable}>
            <TableBody>
              <TableRow>
                <TableCell
                  className={`${classes.customTableColumn} ${classes.tableBodyStyle}`}
                >
                  Section
                </TableCell>
                <TableCell className={classes.tableBodyStyle}>A</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={`${classes.customTableColumn} ${classes.tableBodyStyle}`}
                >
                  Timing
                </TableCell>
                <TableCell className={classes.tableBodyStyle}>
                  10:30 to 1.00 PM
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={`${classes.customTableColumn} ${classes.tableBodyStyle}`}
                >
                  Class Room
                </TableCell>
                <TableCell className={classes.tableBodyStyle}>
                  Room 10
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={`${classes.customTableColumn} ${classes.tableBodyStyle}`}
                >
                  Faculty
                </TableCell>
                <TableCell className={classes.tableBodyStyle}>
                  Prof.Raju
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </KenPopover>
      {/* Master Subject Import */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Master Subject Import
            </Typography>
          </>
        }
        open={masterDialog}
        icon={<RiCheckFill />}
        handleClose={() => masterImportCancel()}
        negativeButtonClick={() => masterImportCancel()}
        positiveButtonClick={() => masterImportSubmit()}
        positiveButtonText="Import"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {masterData.length > 0 ? (
              masterData.map((elem, index) => {
                return (
                  <Accordion expanded={masterAccordian}>
                    <AccordionSummary expandIcon={masterAccordian}>
                      {masterAccordian ? (
                        <AiOutlineMinusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      ) : (
                        <AiOutlinePlusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      )}{' '}
                      &nbsp;{' '}
                      <span style={{ color: '#092682', font: 'Open Sans' }}>
                        {elem.courseName}
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <div className="masterSubject-table">
                          <KenGrid
                            columns={masterHead}
                            data={elem?.array}
                            pagination={{ disabled: true }}
                            toolbarDisabled={true}
                          />
                        </div>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Accordion expanded={masterAccordian}>
                <AccordionSummary expandIcon={masterAccordian}>
                  {masterAccordian ? (
                    <AiOutlineMinusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <span style={{ color: '#092682', font: 'Open Sans' }}>
                    Term 1
                  </span>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <KenGrid
                      columns={masterHead}
                      data={[]}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                    />
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}
          </Grid>
        </Grid>
      </KenDialog>
      {/* Section View */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Select Section
            </Typography>
          </>
        }
        open={sectionViewDialog}
        icon={<RiCheckFill />}
        handleClose={() => sectionViewCancel()}
        negativeButtonClick={() => sectionViewCancel()}
        positiveButtonClick={() => sectionViewSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container xs={12}>
          <Grid xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    {sectionArray.map((ele) => (
                      <TableCell align="left">{ele}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sectionData?.length > 0
                    ? sectionData.map((row, index) => {
                        return (
                          <TableRow key={row.id}>
                            <KenGridEditable
                              {...{
                                row,
                                onChange,
                                editCell,
                                columns: [
                                  {
                                    column_name: 'checkbox',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenCheckbox',
                                  },
                                  {
                                    column_name: 'section',
                                    is_inline_edit: false,
                                    inline_edit_type: '',
                                  },
                                  {
                                    column_name: 'sectionStrength',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenInput',
                                  },
                                ],
                              }}
                            />
                            <TableCell
                              className={classes.selectTableCell}
                              style={{ textAlign: 'center' }}
                            >
                              {row.isEditMode ? (
                                <>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() =>
                                      onToggleEditBtn('done', row.id, index)
                                    }
                                  >
                                    Save
                                  </Button>
                                  <IconButton
                                    aria-label="revert"
                                    onClick={() =>
                                      onToggleRevertBtn(
                                        row.id,
                                        sectionData,
                                        index
                                      )
                                    }
                                  >
                                    <RevertIcon />
                                  </IconButton>
                                </>
                              ) : (
                                <>
                                  {!row.saves && (
                                    <IconButton
                                      aria-label="edit"
                                      onClick={() =>
                                        onToggleEditBtn('edit', row.id, index)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                  {row.saves && (
                                    <>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                          onToggleSaveBtn(
                                            'save',
                                            sectionData,
                                            index
                                          )
                                        }
                                      >
                                        Save
                                      </Button>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() =>
                                          onToggleCancelBtn(
                                            row.id,
                                            sectionData,
                                            index
                                          )
                                        }
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
              <Grid container xs={12}>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={() => addToSectionData('add', sectionData)}
                  style={{ margin: '10px 5px' }}
                >
                  Add
                </Button>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={() => addToSectionData('delete', sectionData)}
                  disabled={activateDelete}
                  style={{ margin: '10px 5px' }}
                >
                  Delete
                </Button>
              </Grid>
            </TableContainer>
          </Grid>
        </Grid>
      </KenDialog>
      {/* Faculty View */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Select Faculty
                </Typography>
              </Grid>
              <Grid container xs={8} style={{ justifyContent: 'right' }}>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(routes.facultySection)}
                >
                  Invite Faculty
                </Button>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={addFacultyToAll}
                >
                  Add Faculty
                </Button>
              </Grid>
            </Grid>
          </>
        }
        open={facultyViewDialog}
        icon={<RiCheckFill />}
        handleClose={() => facultyViewCancel()}
        negativeButtonClick={() => facultyViewCancel()}
        positiveButtonClick={() => facultyViewSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container xs={12}>
          <Grid xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    {facultyArray.map((ele) => (
                      <TableCell align="left">{ele}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facultyData?.length > 0
                    ? facultyData.map((row, index) => {
                        return (
                          <TableRow key={row.id}>
                            <KenGridEditable
                              {...{
                                row,
                                onChange,
                                editCell,
                                columns: [
                                  {
                                    column_name: 'checkbox',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenCheckbox',
                                  },
                                  {
                                    column_name: 'section',
                                    is_inline_edit: false,
                                    inline_edit_type: '',
                                  },
                                  {
                                    column_name: 'sectionStrength',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenInput',
                                  },
                                  {
                                    column_name: 'facultyView',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenSelect',
                                    dropdown: facultyOptions,
                                  },
                                ],
                              }}
                            />
                            <TableCell
                              className={classes.selectTableCell}
                              style={{ textAlign: 'center' }}
                            >
                              {row.isEditMode ? (
                                <>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() =>
                                      onFacultyEditBtn('done', row.id, index)
                                    }
                                  >
                                    Save
                                  </Button>
                                  <IconButton
                                    aria-label="revert"
                                    onClick={() =>
                                      onFacultyRevertBtn(
                                        row.id,
                                        facultyData,
                                        index
                                      )
                                    }
                                  >
                                    <RevertIcon />
                                  </IconButton>
                                </>
                              ) : (
                                <>
                                  {!row.saves && (
                                    <IconButton
                                      aria-label="edit"
                                      onClick={() =>
                                        onFacultyEditBtn('edit', row.id, index)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                  {row.saves && (
                                    <>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                          onFacultySaveBtn(
                                            'save',
                                            facultyData,
                                            index
                                          )
                                        }
                                      >
                                        Save
                                      </Button>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() =>
                                          onFacultyCancelBtn(
                                            row.id,
                                            facultyData,
                                            index
                                          )
                                        }
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </KenDialog>
    </Box>
  );
};

export default FacultyDetails;
